import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Who We Serve", href: "#who-we-serve" },
  { label: "About", href: "#about" },
];

export const Header = ({ onConsult }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,border-color] duration-300 border-b ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-border shadow-[0_4px_24px_rgba(10,31,60,0.06)]"
          : "bg-white/60 backdrop-blur-md border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <a href="#home" data-testid="header-logo-link" className="flex items-center gap-3 group">
          <img
            src="/assets/logo.jpg"
            alt="Cogniti.ai CFO logo"
            className="h-10 w-auto object-contain"
          />
          <span className="font-display font-bold text-lg tracking-tight text-navy">
            Cogniti<span className="text-brand">.ai</span> CFO
          </span>
        </a>

        <nav data-testid="header-nav" className="hidden lg:flex items-center gap-9">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="relative text-sm font-semibold text-navy/80 hover:text-navy transition-colors duration-200 after:absolute after:-bottom-1.5 after:left-0 after:h-[2px] after:w-0 after:bg-brand after:transition-[width] after:duration-300 hover:after:w-full"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-book-consultation-btn"
            onClick={onConsult}
            className="hidden sm:inline-flex items-center rounded-full bg-brand px-6 py-2.5 text-sm font-bold text-navy shadow-[0_6px_20px_rgba(245,166,35,0.35)] transition-[transform,background-color,box-shadow] duration-300 hover:bg-brand-hover hover:text-white hover:scale-[1.03] active:scale-[0.98]"
          >
            Book a Consultation
          </button>
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen(!open)}
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-border text-navy"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-border bg-white/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="font-display text-xl font-semibold text-navy"
              >
                {item.label}
              </a>
            ))}
            <button
              data-testid="mobile-book-consultation-btn"
              onClick={() => {
                setOpen(false);
                onConsult();
              }}
              className="mt-2 rounded-full bg-brand px-6 py-3.5 text-sm font-bold text-navy"
            >
              Book a Consultation
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
